import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import * as OrderFrom from './orderFormComponents/OrderFormParts'
import { log } from '../../Utilities/Utils'
import { ref, firebaseStorage } from '../../config/constants.js'
import { Form, Button, Container, Table, Icon, Segment, Header } from 'semantic-ui-react';
import { firebaseAuth, base } from '../../config/constants'
import * as FbUtils from '../../Utilities/FireBaseUtils'
import numeral from 'numeral';


import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

function ConfirmOrderTable(props) {

    // totalPrice={this.props.totalPrice}
    // numPages={this.props.numPages}
    // totalNumpages={this.props.totalNumpages}
    // blackWhiteColor={this.props.blackWhiteColor}
    return (
        <Table celled>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Total Cost</Table.HeaderCell>
                    <Table.HeaderCell>Num Pages</Table.HeaderCell>
                    <Table.HeaderCell>Total Pages</Table.HeaderCell>
                    <Table.HeaderCell>Color</Table.HeaderCell>
                    <Table.HeaderCell>Stapled</Table.HeaderCell>
                    <Table.HeaderCell>Binding</Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                <Table.Row>
                    <Table.Cell>{numeral(props.totalPrice).format('0,0')}</Table.Cell>
                    <Table.Cell>{props.numPages}</Table.Cell>
                    <Table.Cell>{props.totalNumpages}</Table.Cell>
                    <Table.Cell>{props.blackWhiteColor}</Table.Cell>
                    <Table.Cell>{props.looseStapled}</Table.Cell>
                    <Table.Cell>{props.binding}</Table.Cell>
                </Table.Row>
            </Table.Body>
        </Table>
    )
}

export default class ConfirmOrder extends Component {

    constructor(props) {
        super(props);
        console.log(this.props);
        console.log("xxx:" + this.props.totalPrice);
        console.log("xxx-email :" + this.props.email);

        this.state = {
            showUploadFile: false,
            newPostKey: '',
            uploadComplete: false,
            user: '',
            userFromFirebaseNode: '',
            actualFileName: '',
            orderComplete: false
        }

        this.saveOrder = this.saveOrder.bind(this);
        this.updateWhenFileUploadComplete = this.updateWhenFileUploadComplete.bind(this);
    }

    componentDidMount() {
        log("++++ConfirmOrder - componentDidMount");
        firebaseAuth().onAuthStateChanged((user) => {
            if (user) {
                log("user is signed in:" + user.uid);
                this.setState({
                    user: user
                })
                this.loadUserFromFB(user.uid);
            } else {
                log("user is NOT signed in:" + user.uid);
            }
        });
    }

    //}

    /**
     * THIS FUNCTION WILL GET THE USER OBJECT FORM THE FIREBASE USER NODE TO ADD TO THE ORDER.
     */
    loadUserFromFB = (uid) => {
        log("cox1 +++++++++++ loadUserFromFB");
        // let userTemp = FbUtils.checkForUserInUserNode(uid);

        base.fetch('users', {
            context: this,
            // asArray: true,
            queries: {
                orderByChild: 'uid',
                equalTo: uid
            },
            then(data) {
                //log("cox12 got user data:"+data);
                log("cox13 " + JSON.stringify(data));
                log("cox14:data[Object.keys(data)[0]:" + JSON.stringify(data[Object.keys(data)[0]]));
                //log(data);
                //foo[Object.keys(foo)[0]]
                this.setState({
                    userFromFirebaseNode: data[Object.keys(data)[0]]
                })
            }
        });

        // log("cox12 userTemp:"+JSON.stringify(userTemp));
    }

    /**
     * SAVE ORDER
     */
    // saveOrder = data => ref.child('orders').push(data, response => response); 
    saveOrder(newOrder) {
        // ref.child('orders').push(data, response => response); 
        // Get a key for a new Post.
        let newPostKey = ref.child('orders').push().key;
        this.setState({ newPostKey: newPostKey });
        log("newPostKey:" + newPostKey);
        ref.child('orders/' + newPostKey).set(newOrder);
    }

    /**
     * SEND TO SERVER
     */
    handleSubmit = (e, message) => {
        e.preventDefault();
        log("hx15 >>>>: handleSubmit clicked");

        var d = new Date();
        var n = d.toString();

        let newOrderObject = {
            totalPrice: this.props.totalPrice,
            email: this.props.email,
            phone: this.props.phone,
            numPages: this.props.numPages,
            numCopies: this.props.numCopies,
            location: this.props.location,
            totalNumpages: this.props.totalNumpages,
            blackWhiteColor: this.props.blackWhiteColor,
            dateString: n,
            dateNum: d.getTime(),
            printPhotocopy: this.props.printPhotocopy,
            looseStapled: this.props.looseStapled,
            paperSize: this.props.paperSize,
            singleDoubleSided: this.props.singleDoubleSided,
            binding: this.props.binding,
            fileName: this.props.fileName,
            status: 'new',
            emailsSent: false,
            userUid: this.state.user.uid,
            user: this.state.userFromFirebaseNode,
            verified: false
        }

        this.setState({
            newOrderObjectToConfirm: newOrderObject,
            showUploadFile: true
        });

        this.saveOrder(newOrderObject);
        log("hx16 formObject:" + newOrderObject);

        //UPDATE USER
        if (this.state.user != null) {
            log("daUser:" + this.state.user.uid);

            //CHECK IF USER HAS E-MAIL
            if (this.state.user.email != null) {
                log("user has existing mail no need to update:" + this.state.user.email);

            } else {
                log("no email found updating email:" + this.props.email);

                /**
                 * update fb user object
                 */
                this.state.user.updateEmail(this.props.email).then(() => {
                    log("user email Update successful:" + this.props.email);
                    //UPDATE USER NODE WITH DETAILS..
                    let data = { email: this.props.email, phone: this.props.phone };
                    FbUtils.updateUser(this.state.user.uid, data);
                }).catch(function (error) {
                    log("user email update failed:" + error);
                });

                /**
                 * update fb user node
                 */
                let data = { email: this.props.email, phone: this.props.phone };
                FbUtils.updateUser(this.state.user.uid, data);
            }

        } else {
            log("user is null");
        }

    }

    /**
     * UPDATE STATE WHEN FILE UPLOAD IS COMPLETE
     */
    updateWhenFileUploadComplete(uploadComplete, actualFileName) {
        log("++++++++:updateWhenFileUploadComplete");
        log("actualFileName:" + actualFileName);

        this.setState({
            uploadComplete: true,
            showUploadFile: false,
            actualFileName: actualFileName
        });
    }

    /**
     * finish order
     */
    completeOrder = () => {
        console.log("cx1 ++++++++: completeOrder");

        this.setState({
            orderComplete: true,
            uploadComplete: false
        })

        let data = {
            orderEntryComplete: true
        }

        FbUtils.updateOrder(this.state.newPostKey, data);
    }

    goHome = () => {
        history.push("/");
    }

    render() {

        // const orderDetails = (
        //     <div>
        //         <h1>Confirm Order</h1>
        //         <h2>TOTAL PRICE: {this.props.totalPrice}</h2>
        //         <h4>NUM PAGES: {this.props.numPages}</h4>
        //         <h4>NUM COPIES: {this.props.numCopies}</h4>
        //         <h4>TOTAL NUM PAGES: {this.props.totalNumpages}</h4>
        //         <h4>COLOR: {this.props.blackWhiteColor}</h4>
        //     </div>
        // )

        // const nextButton = (
        //     <div>
        //         <p></p>
        //         <p></p>
        //         <p></p>
        //         <h3> IF ALL IS OK,  UPLOAD UR FILE </h3>
        //         <Form onSubmit={this.handleSubmit}>
        //             <Button type='submit'>NEXT - UPLOAD DOCUMENT</Button>
        //         </Form>
        //     </div>
        // )

        const congrats = (
            <h3>ORDER WILL BE DELIVERED IN THE NEXT HOUR</h3>
        )

        const test = this.state.userFromFirebaseNode == null ? <h2>user not loaded</h2> : <h2>user loaded:{this.state.userFromFirebaseNode.phone}</h2>;

        /**
         * CHANGE DETAILS BUTTONS
         */
        const changeOrderDetailsButton = (
            this.state.showUploadFile || this.state.uploadComplete || this.state.orderComplete ? '' :
                <Button>
                    <Link to={'/newOrder'}>BACK - EDIT ORDER</Link>
                </Button>
        )

        /**
         * NEXT BUTTON
         */
        const nextToFileUploadButtonConst = (
            this.state.uploadComplete || this.state.showUploadFile || this.state.orderComplete ? '' :
                <Button onClick={this.handleSubmit} color='green' content='Next - Upload File' ></Button>
        )

        const stapledOrNot = this.props.looseStapled === 'loose' ? 'No' : 'Yes';

        /**
         * CONFIRM ORDER TABLE
         */
        const uploadFileUiConst = (!this.state.showUploadFile && !this.state.orderComplete ? <ConfirmOrderTable
            totalPrice={this.props.totalPrice}
            numPages={this.props.numPages}
            totalNumpages={this.props.totalNumpages}
            blackWhiteColor={this.props.blackWhiteColor}
            looseStapled={stapledOrNot}
            binding={this.props.binding}
        /> : ""
        )

        /**
         * FILE UPLOAD UI
         */
        const fileHeaderUI = (!this.state.showUploadFile ? "" :
            <div>
                <Header as='h2' icon textAlign='center'>
                    <Header.Content>
                        Select File to Print
                        <OrderFrom.UploadFile
                            fileName={this.state.newPostKey}
                            updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                        />
                    </Header.Content>

                </Header>
            </div>
        )

        /**
         * CONFIRM ORDER UI
         */
        const confirmOrderHeaderUi = (
            <div>
                <Header as='h2' icon textAlign='center'>
                    <Icon name='checkmark' circular />
                    <Header.Content>
                        Confirm Order
                    </Header.Content>
                </Header>
            </div>
        )

        /**
         * HEADER THAT SHOWS WHEN ORDER IS BEING CONFRIMED
         */
        const confirmOrderHeaderConst = (
            !this.state.showUploadFile && !this.state.uploadComplete && !this.state.orderComplete ?
                <OrderFrom.OrderProcessHeader icon='checkmark' headerText='Confirm Order' />
                : ""
        )

        /**
         * HEADER THAT SHOWS BEFORE FILE UPLOAD
         */
        const uploadFileHeaderConst = (
            this.state.showUploadFile && !this.state.uploadComplete && !this.state.orderComplete
                ? <OrderFrom.OrderProcessHeader icon='folder open' headerText='File Upload' />
                : ""
        )

        /**
         * HEADER THAT SHOWS TO CONFIRM FILE
         */
        const confirmFileHeaderConst = (
            !this.state.showUploadFile && this.state.uploadComplete ? <OrderFrom.OrderProcessHeader icon='checkmark' headerText='Confirm File' />
                : ""
        )

        // const confirmOrderHeaderConst = (
        //     this.state.showUploadFile && !this.state.uploadComplete ? <OrderFrom.OrderProcessHeader icon='checkmark' headerText='Confirm Order'/> 
        //     : <OrderFrom.OrderProcessHeader icon='folder open' headerText='File Upload'/>
        // )

        const changeFileConst = (
            this.state.uploadComplete
                ? <div>
                    {/* <Header textAlign='center' as='h2'>{this.state.actualFileName}</Header> */}
                    <Header as='h3' icon textAlign='center'>
                        <Header.Content>
                            {this.state.actualFileName} - uploaded
                        </Header.Content>
                        <Header.Content>
                            Change File below:
                           <OrderFrom.UploadFile
                                fileName={this.state.newPostKey}
                                updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                            />
                        </Header.Content>
                    </Header>
                    <Container textAlign='center'>
                        <Button onClick={this.completeOrder} color='green' size='massive' content='Finish' icon='checkmark' labelPosition='right' />
                    </Container>

                </div>
                : ""
        )

        const orderCompleteUiConst = (
            <div>
                <OrderFrom.OrderProcessHeader icon='motorcycle' headerText='THANK YOU ORDER WILL BE REC IN AN HOUR' />
                <Header size='medium' textAlign='center'>
                    <Button onClick={this.goHome} positive>
                        {/* <Link to={'/'}>HOME</Link> */}
                        HOME
                    </Button>
                </Header>
            </div>
        )

        return (
            <Container>
                {confirmOrderHeaderConst}
                {uploadFileHeaderConst}
                {confirmFileHeaderConst}
                {this.state.uploadComplete ? '' :
                    <div>
                        {/* {confirmOrderHeaderConst} */}
                        {uploadFileUiConst}
                    </div>
                }
                <h1></h1>
                {changeOrderDetailsButton}

                {fileHeaderUI}

                {nextToFileUploadButtonConst}

                {/* {!this.state.showUploadFile ?
                    '' :
                    <OrderFrom.UploadFile
                        fileName={this.state.newPostKey}
                        updateWhenFileUploadComplete={this.updateWhenFileUploadComplete}
                    />} */}

                {changeFileConst}

                {this.state.orderComplete ? orderCompleteUiConst : ''}

            </Container>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/orderProcess/ConfirmOrder.js